'use client'

import { Effect, pipe } from 'effect'
import { useCallback } from 'react'
import { useGameActions } from 'src/store/game'
import { unknownGame } from 'src/types/domain/Game'
import { getGameById } from 'src/services/supabase/queries'

export function useGameAPI() {
  const gameActions = useGameActions()

  const fetchCurrentGame = useCallback(
    async (raceConfigurationId: string) => {
      const game = await pipe(
        getGameById({ gameId: raceConfigurationId }),
        Effect.orElseSucceed(() => unknownGame),
        Effect.runPromise
      )

      gameActions.setCurrentGame({ ...game })
    },
    [gameActions]
  )

  return { fetchCurrentGame }
}
